<template>
    <div class="scrollWrap">
        <div class="page_views">
            <!-- 1 -->
            <div class="headerMenu page_me">
                <div class="page_front">
                    <img class="page_image" src="../assets/ico.png" />
                    <div class="page_v_size" @click="frontseatHome">front<span style="color: #E2BF6B;">seat</span></div>
                </div>
                <div class="page_wrap" style="position: relative;">
                    <div @click="tabClick(1)" :class="[tabs == 1 ? 'acount_v' : 'page_tab']">首页</div>
                    <div 
                        @mouseover="showSubMenu(2)" 
                        @mouseleave="hideSubMenu(2)" 
                        @click="tabClick(2)" 
                        :class="[tabs == 2 ? 'acount_v' : 'page_tab', 'page_hover']"
                    >
                        服务与解决方案
                        <div class="submenu" v-if="showMenu === 2">
                            <div @click="tabClick(21)" class="submenu-item">品牌代理</div>
                            <div @click="tabClick(22)" class="submenu-item">市场</div>
                        </div>
                    </div>
                    <div @click="tabClick(3)" :class="[tabs == 3 ? 'acount_v' : 'page_tab']">平台功能</div>
                    <div @click="tabClick(4)" :class="[tabs == 4 ? 'acount_v' : 'page_tab']">门店</div>
                    <div @click="tabClick(5)" :class="[tabs == 5 ? 'acount_v' : 'page_tab']">客户案例</div>
                    <div @click="tabClick(6)" :class="[tabs == 6 ? 'acount_v' : 'page_tab']">联系</div>
                </div>
                <div v-if="isEn == false" @click="isEn = true" class="page_set_v">中文</div>
                <div v-if="isEn == true"  @click="isEn = false" class="page_set_v">En</div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            isShowTab: false,
            tabs: 1,
            showMenu: null, // 用于控制显示哪个子菜单
            isEn:false
        }
    },
    watch: {
        //监听路由数据变化
        $route: {
            immediate: true,
            handler(to, from) {
                this.toPath(to.path)
            }

        }
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll)
    },
    methods: {
        toPath(path) {
            const routes = {
                '/': 1,
                '/servicesandSolutions': 2,
                '/servicesandSolutions/brandAgency': 21,
                '/servicesandSolutions/market': 22,
                '/platformFunctions': 3,
                '/storefront': 4,
                '/customerCaseStudies': 5,
                '/contact': 6,
            }
            this.tabs = routes[path] || 1
        },
        tabClick(index) {
            const paths = {
                1: '/',
                2: '/servicesandSolutions',
                21: '/servicesandSolutions/brandAgency',
                22: '/servicesandSolutions/market',
                3: '/platformFunctions',
                4: '/storefront',
                5: '/customerCaseStudies',
                6: '/contact',
            }
            this.tabs = index
            this.$router.push(paths[index])
        },
        frontseatHome() {
            this.tabs = 1
            this.$router.push('/')
        },
        showSubMenu(index) {
            this.showMenu = index
        },
        hideSubMenu(index) {
            if (this.showMenu === index) {
                this.showMenu = null
            }
        },
    },
}
</script>
<style scoped>
.page_views {
    position: fixed;
    top: 0;
    left: 0;
    color: #fff;
    z-index: 999;
    width: 100%;
    height: 200px;
}

.headerMenu {
    display: flex;
    align-items: center;
    height: 5.1rem;
}

.page_me {
    background-color: #222222;
}

.page_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 32%;
}

.page_front {
    display: flex;
    align-items: center;
    width: 30%;
    font-size: 1.5rem;
    box-sizing: border-box;
}

.page_v {
    margin-left: 20%;
}

.page_v_size {
    color: #fff;
}

.page_set {
    padding: 4px 12px;
    background-color: #fff;
    margin-left: 10%;
    color: #fff;
    border-radius: 2px;
    display: flex;
    align-items: center;
}

.page_set_v {
    margin-left: 30%;
    color: #E2BF6B;
}

.acount_v {
    border-bottom: 2px solid #E2BF6B;
    color: #E2BF6B;
}

.page_image {
    margin-left: 20%;
    width: 2.6rem;
    height: 2.6rem;
}

.page_tab:hover {
    border-bottom: 2px solid #E2BF6B;
    color: #E2BF6B;
}

.submenu {
    position: absolute;
    top: 100%; /* 放置在父菜单项的下方 */
    left: 4rem;
    background-color: #222222;
    padding: 1rem 0;
    box-shadow: 0 0.25rem 0.5rem rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    z-index: 1000; /* 确保子菜单在其他内容之上 */
}
 
.submenu-item {
    padding: 0.8rem 1.25rem;
    cursor: pointer;
    color: #fff;
    white-space: nowrap;
}
 
.submenu-item:hover {
   color: #E5BF67;
}
</style>
